// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"df447a43","181":"b76a6d84","319":"19a5ec2a","605":"4a6f5b70","913":"05e2e57b"}[chunkId] + ".chunk.css";
};